module.exports = __webpack_public_path__ + "static/media/broccoli-cheddar-dumpling.d380a6e0.png";